
export const getAuctionUser = store => {
  return store.auctionUser
}

export const getBidSubscriptionResponse = store => {
  return store.bidSubscriptionResponse
}

export const getFixedItemSubscriptionResponse = store => {
  return store.fixedItemSubscriptionResponse
}

export const getDonationSubscriptionResponse = store => {
  return store.donationSubscriptionResponse
}

export const getLiveAuctionCode = store => {
  return store.liveAuctionCode
}

